var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user_square_24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x86\xB3 Icon Color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.53286 3.66938C1 4.71517 1 6.08419 1 8.82222V15.1778C1 17.9158 1 19.2848 1.53286 20.3306C2.00157 21.2505 2.74948 21.9984 3.66938 22.4671C4.71517 23 6.08419 23 8.82222 23H15.1778C17.9158 23 19.2848 23 20.3306 22.4671C21.2505 21.9984 21.9984 21.2505 22.4671 20.3306C23 19.2848 23 17.9158 23 15.1778V8.82222C23 6.08419 23 4.71517 22.4671 3.66938C21.9984 2.74948 21.2505 2.00157 20.3306 1.53286C19.2848 1 17.9158 1 15.1778 1H8.82222C6.08419 1 4.71517 1 3.66938 1.53286C2.74948 2.00157 2.00157 2.74948 1.53286 3.66938ZM12 5.88889C13.6882 5.88889 15.0556 7.25625 15.0556 8.94444C15.0556 10.6326 13.6882 12 12 12C10.3118 12 8.94444 10.6326 8.94444 8.94444C8.94444 7.25625 10.3118 5.88889 12 5.88889ZM5.88889 17.3434V16.6068C5.88889 13.9744 9.96042 13.2222 12 13.2222C14.0396 13.2222 18.1111 13.9744 18.1111 16.6068V17.3434C18.1111 17.7674 17.7674 18.1111 17.3434 18.1111H6.6566C6.2326 18.1111 5.88889 17.7674 5.88889 17.3434Z",
    fill: "#322267"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLk);
export default __webpack_public_path__ + "static/media/lk.c1786af50b9362f87c9dff9fbe16dbba.svg";
export { ForwardRef as ReactComponent };